import React from 'react';

import TestimonialCard from '@core/components/contentparser/sections/Testimonials/TestimonialCard/TestimonialCard';
import ScrollAnimation from 'react-animate-on-scroll';
import ActionButton from '@core/components/actionbutton/ActionButton';

import classes from './PlansTestimonials.module.scss';

const PlansTestimonials = ({data}) => {
     const [expanded, setExpanded] = React.useState(false);

    const handleLoadMore = () => {
        setExpanded(true);
    };

    return (
        <div className='container' style={{ position: 'relative' }}>
            <div
                className={classes['wrapper']}
                style={{
                    padding: '0 20px',
                    maxHeight: expanded ? 'none' : '700px',
                    overflowY: expanded ? 'visible' : 'hidden',
                    transition: 'max-height 1s ease',
                    position: 'relative'
                }}
            >
                <ScrollAnimation animateIn="fadeInUp" duration={1}>
                    <h3>How learners are achieving their goals</h3>
                    <h5>
                        Get started now on your learning journey with a set of courses that cover essential business skills.
                    </h5>
                </ScrollAnimation>
                <div className="row d-none d-xl-flex">
                    <div className="col-xl-4 ">
                        <TestimonialCard data={data[0]} />
                        <TestimonialCard data={data[3]} />
                        <TestimonialCard data={data[6]} />
                    </div>
                    <div className="col-xl-4 ">
                        <TestimonialCard data={data[1]} />
                        <TestimonialCard data={data[4]} />
                        <TestimonialCard data={data[7]} />
                    </div>
                    <div className="col-xl-4 ">
                        <TestimonialCard data={data[2]} />
                        <TestimonialCard data={data[5]} />
                        <TestimonialCard data={data[8]} />
                    </div>
                </div>
                <div className="row d-none d-lg-flex d-xl-none">
                    <div className="col-lg-6 ">
                        <TestimonialCard data={data[0]} />
                        <TestimonialCard data={data[2]} />
                        <TestimonialCard data={data[4]} />
                        <TestimonialCard data={data[6]} />
                        <TestimonialCard data={data[8]} />
                    </div>
                    <div className="col-lg-6 ">
                        <TestimonialCard data={data[1]} />
                        <TestimonialCard data={data[3]} />
                        <TestimonialCard data={data[5]} />
                        <TestimonialCard data={data[7]} />
                    </div>
                </div>
                <div className="row d-flex d-lg-none">
                    <div className="col-lg-12">
                        <TestimonialCard data={data[0]} />
                        <TestimonialCard data={data[1]} />
                        <TestimonialCard data={data[2]} />
                    </div>
                </div>
                {!expanded && (
                    <div
                        style={{
                            position: 'absolute',
                            left: 0,
                            right: 0,
                            bottom: 0,
                            height: '200px',
                            background: 'linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.95) 100%)',
                            pointerEvents: 'none',
                            transition: 'opacity 0.5s',
                            zIndex: 2
                        }}
                    />
                )}
            </div>
            {!expanded && (
                <div className={classes['button-wrapper']}>
                    <ActionButton kind='secondary' onClick={handleLoadMore}>
                        Load More
                    </ActionButton>
                </div>
            )}
        </div>
    );
};

export default PlansTestimonials;